const data = {
  "width": 24,
  "height": 24,
  "body": "<path fill=\"currentColor\" d=\"M19.2 2.43L16.778 0L4.8 12l11.978 12l2.422-2.43L9.653 12z\"/>"
};
exports.__esModule = true;
exports.default = data;